
import React, {useState, useEffect} from 'react';
import config from '../../config/apiConfig';

//loader
import BeatLoader from "react-spinners/BeatLoader";


export default function Procesando() {

    const loading = true;
   
    return(
    <div>
        <div className="row">
          <div className="col-md-12 d-flex justify-content-center">
                <BeatLoader color={config.color_loader}  loading={loading}  size={50} />
          </div>
        </div>
    </div>)
}